import { render, staticRenderFns } from "./MediaLibrary.vue?vue&type=template&id=454b6320&"
import script from "./MediaLibrary.vue?vue&type=script&lang=js&"
export * from "./MediaLibrary.vue?vue&type=script&lang=js&"
import style0 from "./MediaLibrary.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports